import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Container, Row, Col, Button, Image, Form } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { ApiManager } from '../../core/api-manager';
import { Utils } from '../../core/utils';
import { toast } from 'react-toastify';
import logo from '../../assets/logo.svg';


export default function Register() {

    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [submitting, setSubmitting] = useState(false);


    async function handleRegister(e) {
        e.preventDefault();
        if (submitting) return;

        const n = name.trim();
        const s = surname.trim();
        const em = email.trim();
        if (!n || !s || !em || !password) {
            toast.error('Inserire tutti i campi.', { theme: 'colored' });
            return;
        }
        if (password !== confirmPassword) {
            toast.error('Le password non coincidono', { theme: 'colored' });
            return;
        }
        if (password.length < 6) {
            toast.error('La password deve essere di almeno 6 caratteri', { theme: 'colored' });
            return;
        }

        setSubmitting(true);
        try {
            const body = {
                name: n,
                surname: s,
                email: em,
                password: Utils.encrypt(password)
            };
            const res = await ApiManager.sendRequest('/public/do_register', body);
            if (res.success === 1 && res.status === 200) {
                toast.success('Utente creato con successo!', { theme: 'colored' });
                localStorage.setItem('ltsid', res.ltsid);
                localStorage.setItem('sid', res.sid);
                localStorage.setItem('userInfo', JSON.stringify(res.body));
                navigate('/');
            } else if (res.message === 'user.exist' || res.error_code === 'user.exist') {
                toast.error("Esiste già un utente con questa email.", { theme: 'colored' });
            } else {
                toast.error('Errore in fase di registrazione.', { theme: 'colored' });
            }
        } catch (err) {
            console.error('register error', err);
            toast.error('Errore in fase di registrazione.', { theme: 'colored' });
        } finally {
            setSubmitting(false);
        }
    }


    return (
        <>

            <Container fluid style={{ height: '100vh' }}>
                <Row md={12} xs={12}>
                    <Col md={4}></Col>
                    <Col md={4} xs={12} className='align-items-center'>
                        <Image src={logo} style={{ width: '100%' }}></Image>
                        <h4 className='text-center'>Registrati</h4>
                        <p className='text-center'>Compila i campi per continuare</p>
                        <Form onSubmit={handleRegister}>
                            <Form.Group controlId="formName" className='mt-5' >
                                <Form.Label>Nome</Form.Label>
                                <Form.Control type="text" placeholder={LanguageProvider.get('pages.register.name')} value={name} onChange={(e) => setName(e.target.value)} autoComplete='given-name' />
                            </Form.Group>
                            <Form.Group controlId="formSurname" className='mt-3'>
                                <Form.Label>Cognome</Form.Label>
                                <Form.Control type="text" placeholder={LanguageProvider.get('pages.register.surname')} value={surname} onChange={(e) => setSurname(e.target.value)} autoComplete='family-name' />
                            </Form.Group>
                            <Form.Group controlId="formEmail" className='mt-3'>
                                <Form.Label>Indirizzo email</Form.Label>
                                <Form.Control type="email" placeholder={LanguageProvider.get('pages.register.email')} value={email} onChange={(e) => setEmail(e.target.value)} autoComplete='email' />
                            </Form.Group>
                            <Form.Group controlId="formPassword" className='mt-3'>
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder={LanguageProvider.get('pages.register.password')} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete='new-password' />
                                <Form.Text className='text-muted'>Almeno 6 caratteri.</Form.Text>
                            </Form.Group>
                            <Form.Group controlId="formConfirmPassword" className='mt-3'>
                                <Form.Label>Conferma password</Form.Label>
                                <Form.Control type="password" placeholder='Ripeti la password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} autoComplete='new-password' />
                            </Form.Group>
                            <Button style={{ color: 'white', backgroundColor: '#22ae6e', borderColor: '#22ae6e' }} type="submit" className='w-100 mt-5' disabled={submitting}>
                                {submitting ? 'Invio...' : LanguageProvider.get('pages.register.submit')}
                            </Button>
                        </Form>
                        <Row className='mt-5'>
                            <p className='text-center'>{LanguageProvider.get('forms.registrati_footer')}</p>
                            <Button as={Link} to='/login' style={{ color: '#22ae6e', backgroundColor: 'white', borderColor: '#22ae6e' }}>
                                {LanguageProvider.get('buttons.accedi')}
                            </Button>
                        </Row>
                    </Col>
                    <Col md={4}></Col>
                </Row>
            </Container>
        </>
    )


};
